import React, { useEffect } from "react"
import useTranslationHook from "../hooks/use-translation.hook"
import { AppFunctionComponent } from "../types"

const TranslateContentWrapper: AppFunctionComponent = ({ children }) => {
  const { fetchAndSaveCountry } = useTranslationHook()
  useEffect(() => {
    fetchAndSaveCountry()
  }, [])
  return <>{children}</>
}

export default TranslateContentWrapper
